export default {"src":"/_next/static/media/1.0fb1ed8f.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};